import { httpsCallable } from 'firebase/functions';
import type { Functions, HttpsCallableStreamOptions } from 'firebase/functions';

export const createCallableRouteInvoker =
  (functions: Functions) =>
  async <TResponse, TRequest>(
    callableName: string,
    requestData?: TRequest,
  ): Promise<TResponse> => {
    const result = await httpsCallable(functions, callableName)(requestData);

    return result.data as TResponse;
  };

export const createCallableStreamRouteInvoker =
  (functions: Functions) =>
  <TResponse, TRequest>(
    callableName: string,
    requestData?: TRequest,
    options?: HttpsCallableStreamOptions,
  ): Promise<TResponse> => {
    return httpsCallable(functions, callableName).stream(
      requestData,
      options,
    ) as Promise<TResponse>;
  };
